module.exports = __webpack_public_path__ + "assets/ios_Filez_limit.70de4feda7283fd534122c4e951d305a.png";